import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GcContainerComponent, SkipContainer } from "./container.component";

// External modules
import { AccordionModule } from "primeng/accordion";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { ColorPickerModule } from "primeng/colorpicker";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from "primeng/inputtext";
import { ListboxModule } from "primeng/listbox";
import { MultiSelectModule } from "primeng/multiselect";
import { PasswordModule } from "primeng/password";
import { RadioButtonModule } from "primeng/radiobutton";
import { SelectButtonModule } from "primeng/selectbutton";
import { SliderModule } from "primeng/slider";
import { ToggleButtonModule } from "primeng/togglebutton";
import { TreeSelectModule } from "primeng/treeselect";
import { DividerModule } from "primeng/divider";
import { AvatarGroupModule } from "primeng/avatargroup";
import { ProgressBarModule } from "primeng/progressbar";
import { PopoverModule } from "primeng/popover";
import { DrawerModule } from "primeng/drawer";
import { TagModule } from "primeng/tag";
import { CardModule } from "primeng/card";
import { SharedModule } from "primeng/api";
import { AvatarModule } from "primeng/avatar";
import { SplitButtonModule } from "primeng/splitbutton";
import { PanelModule } from "primeng/panel";

// Modules to export
import { GcAutoCompleteComponent } from "./components/auto-complete";
import { GcAvatarComponent } from "./components/avatar";
import { GcButtonComponent } from "./components/button";
import { GcCheckboxComponent } from "./components/checkbox";
import { GcColorPickerComponent } from "./components/color-picker";
import { GcInputTextComponent } from "./components/input-text";
import { GcTemplate } from "./directives/gcTemplate";
import { GcFooter, GcHeader } from "./components/shared";
import { GcCardComponent } from "./components/card";
import { GcInputNumberComponent } from "./components/input-number";
import { GcListboxComponent } from "./components/listbox";
import { GcMultiSelectComponent } from "./components/multiselect";
import { GcPasswordComponent } from "./components/password";
import { GcProgressbarComponent } from "./components/progressbar";
import { GcOverlayPanelComponent } from "./components/overlay-panel";
import { GcRadiobuttonComponent } from "./components/radio-button";
import { GcSelectButtonComponent } from "./components/select-button";
import { GcSidebarComponent } from "./components/sidebar";
import { GcSliderComponent } from "./components/slider";
import { GcTagComponent } from "./components/tag";
import { GcToggleButtonComponent } from "./components/toggle-button";
import { GcTreeSelectComponent } from "./components/tree-select";
import { GcPanelComponent } from "./components/panel";
import { GcSplitButtonComponent } from "./components/split-button";
import { GcStepsComponent } from "./components";
import { ToastModule } from "primeng/toast";
import { TooltipModule } from "primeng/tooltip";
import { VTooltipModule } from "src/app/components/v-tooltip/v-tooltip-module";
import { RouterModule } from "@angular/router";



const components = [
    GcAutoCompleteComponent,
    GcAvatarComponent,
    GcCheckboxComponent,
    GcColorPickerComponent,
    GcCardComponent,
    GcInputNumberComponent,
    GcInputTextComponent,
    GcListboxComponent,
    GcMultiSelectComponent,
    GcPasswordComponent,
    GcProgressbarComponent,
    GcOverlayPanelComponent,
    GcRadiobuttonComponent,
    GcSelectButtonComponent,
    GcSidebarComponent,
    GcSliderComponent,
    GcTagComponent,
    GcToggleButtonComponent,
    GcTreeSelectComponent,
    GcSplitButtonComponent,
    GcStepsComponent,

    GcPanelComponent,

    GcHeader,
    GcFooter,
    GcTemplate,

    SkipContainer,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode'}),
        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode'}),
        RouterModule,

        //external modules
        AccordionModule,
        AutoCompleteModule,
        AvatarGroupModule,
        ButtonModule,
        CheckboxModule,
        ColorPickerModule,
        DividerModule,
        CardModule,
        SharedModule,
        InputNumberModule,
        InputTextModule,
        ListboxModule,
        MultiSelectModule,
        PasswordModule,
        ProgressBarModule,
        PopoverModule,
        RadioButtonModule,
        SelectButtonModule,
        DrawerModule,
        SliderModule,
        TagModule,
        ToastModule,
        ToggleButtonModule,
        TreeSelectModule,
        AvatarModule,
        SplitButtonModule,
        TooltipModule,
        VTooltipModule,

        PanelModule,
        GcButtonComponent,

    ],
    exports: [
        ...components,
        GcContainerComponent,
        GcButtonComponent,
    ],
    declarations: [
        ...components,
        GcContainerComponent
    ],
})
export class GcReactiveForms {}
